export const restrictsExchangeAddressInputName = 'restricts_exchange_address'
